import { produce } from 'immer';

import { UpdateInternalMarketerProduct } from '../../../actions/marketer/internal/updateInternalMarketerProduct';
import { MarketerState } from '../../../typings/marketers';

export function updateInternalMarketerProduct(
    state: MarketerState,
    action: UpdateInternalMarketerProduct
): MarketerState {
    return produce(state, draft => {
        const product = draft.marketer.ownProducts.find(item => item.id === action.product.id);

        if (product) {
            product.id = action.product.id;
            product.productName = action.product.productName;
            product.productLogin = action.product.productLogin;
            product.access = action.product.access;
            product.placeIds = action.product.placeIds;
            product.isSaved = action.product.isSaved;
            product.isRemoving = action.product.isRemoving;

            if (action.isSaved !== undefined) {
                product.isSaved = action.isSaved;
            }

            if (action.isRemoving !== undefined) {
                product.isRemoving = action.isRemoving;
            }
        }
    });
}
